import { Props_SnippetIconsTextHover } from "./IconsTextHover.props";
import { CompileHeadingToSpan, CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SnippetLink from "Shared/Link/Link";

export const SnippetIconsTextHover = (props: Props_SnippetIconsTextHover) => {
    const { heading, repeatable_iconsTextOptions, ctaButton } = props;

    const classHeadingVisibility = heading.visibility.value 
        ? "snippet-icons-text-hover__heading" 
        : "snippet-icons-text-hover__heading accessible-heading";

    return (
        <section className="snippet-icons-text-hover">
            <div className="snippet-icons-text-hover__container">
                <h2 className="snippet-icons-text-hover__header">
                    {heading?.content?.value && <div className={classHeadingVisibility}>{CompileHeadingToSpan(heading.content.value)}</div>}
                </h2>

                <div className="snippet-icons-text-hover__card-container">
                    {repeatable_iconsTextOptions.map((iconsText, index) => (
                        <div key={`card-${index}`} className="snippet-icons-text-hover__card">
                            <div className="snippet-icons-text-hover__card-inner">
                                {/* Front Side - Image and Heading */}
                                <div className="snippet-icons-text-hover__card-front">
                                    {iconsText?.image?.value && (
                                        <figure className="snippet-icons-text-hover__icon-container">
                                            <img
                                                loading="lazy"
                                                src={iconsText.image.value}
                                                alt=""
                                                className="snippet-icons-text-hover__icon"
                                                height="100"
                                                width="100"
                                            />
                                        </figure>
                                    )}
                                    {iconsText?.iconHeading?.value && (
                                        <h3 className="snippet-icons-text-hover__card-heading">{CompileHeadingToSpan(iconsText.iconHeading.value)}</h3>
                                    )}
                                </div>

                                {/* Back Side - Text */}
                                <div className="snippet-icons-text-hover__card-back">
                                    {iconsText?.content?.value && <div className="snippet-icons-text-hover__text">{CompileMarkdown(iconsText.content.value)}</div>}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                 <SnippetLink
                                    linkStyles={ctaButton.linkStyle?.value}
                                    className="snippet-icons-text-hover__link"
                                    url={ctaButton.linkHref?.value}
                                    openInNewTab={ctaButton.linkTarget?.value}
                                >
                                    {ctaButton.linkText?.value}
                                </SnippetLink>
            </div>
        </section>
    );
};
